import * as React from 'react';
import cx from 'classnames';
import { map } from 'lodash';

import { Tooltip } from 'antd';
import { EditorState } from 'draft-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faListOl, faListUl } from '@fortawesome/free-solid-svg-icons';
import { TBlockType } from './types';

const LIST_TYPE_ICON: {
  [key in TBlockType]?: React.ReactNode;
} = {
  'ordered-list-item': <FontAwesomeIcon icon={faListOl} className="h-3 w-3 text-primary" />,
  'unordered-list-item': <FontAwesomeIcon icon={faListUl} className="h-3 w-3 text-primary" />,
};
const LIST_TYPES: TBlockType[] = [
  'ordered-list-item', 'unordered-list-item',
];
const LIST_TYPE_NAME: {
  [key in TBlockType]?: string;
} = {
  'ordered-list-item': 'Numbered list',
  'unordered-list-item': 'Bullet list',
};
const LIST_TYPE_HOTKEY: {
  [key in TBlockType]?: string;
} = {
  'ordered-list-item': '⌘7',
  'unordered-list-item': '⌘8',
};

interface IProps {
  editorState: EditorState;
  toggleBlockType(type: TBlockType): void;

  className?: string;
}

/**
 * @type {React.FC}
 */
export const ListTypes: React.FC<IProps> = React.memo((props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className={cx('flex items-center gap-1', props.className)}>
      {map(LIST_TYPES, (type) => (
        <Tooltip
          key={type}
          title={(
            <div className="flex items-center gap-3 font-medium text-xs">
              {LIST_TYPE_NAME[type]}
              <span className="bg-gray-600 text-white px-1.5 py-0.5 rounded text-xs">
                {LIST_TYPE_HOTKEY[type]}
              </span>
            </div>
          )}
        >
          <div
            className={cx(
              'flex items-center justify-center w-6 h-6 rounded cursor-pointer transition-all duration-150 hover:bg-grey-2',
              {
                'bg-gray-100 text-blue-600': blockType === type,
              }
            )}
            onMouseDown={(event) => {
              event.preventDefault();

              props.toggleBlockType(type);
            }}
          >
            {LIST_TYPE_ICON[type]}
          </div>
        </Tooltip>
      ))}
    </div>
  );
});

ListTypes.displayName = 'ListTypes';
